import baseService from '../shared/baseService';

const clippingParametersService = (clipperId: number) =>
    baseService(`clippers/${clipperId}/clipping-parameters`);

export default { 
    clippingParametersService
};

